module.exports = __webpack_public_path__ + "static/media/Tick-Box-Active.3a177f53.svg";